import {
  AddChargeComplete,
  DeleteChargeComplete,
  DeleteChargesComplete,
  LoadChargesByIdsComplete,
  LoadChargesComplete,
  UpdateChargeComplete,
} from './actions'
import { adapter, initialState, State } from './state'
import * as R from 'ramda'
import { Action, createReducer, on } from '@ngrx/store'

export const reducer = createReducer(
  initialState,
  on(LoadChargesComplete, (state, { charges }) => adapter.upsertMany(charges, R.merge(state, { isLoaded: true }))),
  on(LoadChargesByIdsComplete, (state, { charges }) => adapter.addMany(charges, state)),
  on(AddChargeComplete, (state, { charge }) => adapter.addOne(charge, state)),
  on(UpdateChargeComplete, (state, { update }) => adapter.updateOne(update, state)),
  on(DeleteChargeComplete, (state, { id }) => adapter.removeOne(id, state)),
  on(DeleteChargesComplete, (state, { ids }) => adapter.removeMany(ids, state))
)

export function chargeReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
